var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"central-control-station"},[_c('span',{staticClass:"welcome"},[_vm._v("Welp gg")]),_vm._v(" Error code: "+_vm._s(_vm.statusCode)+" "),_c('br'),_vm._v(" Error message: "+_vm._s(_vm.errorMessage)+" "),_c('br'),_vm._v(" Please try again in a while and feel free to contact us ")])
}
var staticRenderFns = []

export { render, staticRenderFns }